import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, timer, Subscription } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AutoLogoutDialogComponent } from 'app/pages/dashboard/timesheet/auto-logout-dialog/auto-logout-dialog.component';
import { AuthService } from './auth.service';
import { ApiActivityService } from './api-activity.service';

@Injectable({
  providedIn: 'root',
})
export class AutoLogoutService {
  private userActivityEvents = [
    'click',
    'mousemove',
    'keydown',
    'scroll',
    'touchstart',
  ];
  private activitySubscription!: Subscription;
  private logoutTimer$ = timer(5000);

  constructor(
    private router: Router,
    private ngZone: NgZone,
    public dialog: MatDialog,
    private authService: AuthService,
    private apiActivityService: ApiActivityService
  ) {}

  initListener() {
    this.ngZone.runOutsideAngular(() => {
      const uiActivity$ = merge(
        ...this.userActivityEvents.map((event) => fromEvent(document, event))
      );

      const apiActivity$ = this.apiActivityService.apiActivity$;

      const allActivity$ = merge(uiActivity$, apiActivity$);

      this.activitySubscription = allActivity$
        .pipe(
          filter(() => this.authService.isLoggedIn()),
          switchMap(() => this.logoutTimer$)
        )
        .subscribe(() => {
          this.ngZone.run(() => {
            this.logout();
          });
        });
    });
  }

  logout() {
    if (this.authService.isLoggedIn()) {
      this.dialog.open(AutoLogoutDialogComponent);
    }
  }

  stop() {
    this.activitySubscription?.unsubscribe();
  }
}
